import Markdown from 'markdown-to-jsx';
import { useCallback, useContext, useState } from 'react';
import { AppContext } from 'providers/AppProvider';

type RiskqTextRRSURowProps = Readonly<{
	text: string;
	title: string;
}>;

export function RiskqTextRRSURow(props: RiskqTextRRSURowProps) {
	const { t } = useContext(AppContext);
	const [visible, setVisible] = useState(false);
	const toggle = useCallback(() => setVisible(!visible), [visible]);
	return (
		<div className="my-4" key={props.text}>
			<button className="bold text-secondary toggle" onClick={toggle}>
				{t(props.title, 'riskq')}
			</button>
			{visible && (
				<div className="arionui">
					<Markdown options={{ forceBlock: true }}>{t(props.text, 'testRisk')}</Markdown>
				</div>
			)}
		</div>
	);
}
